document.addEventListener('DOMContentLoaded', () => {
  const initCarousel = () => {
    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(initCarousel, 100);
      return;
    }

    const carousels = document.querySelectorAll('.mokotracker-feature-carousel.embla');

    for (const carousel of carousels) {
      const viewport = carousel.querySelector('.embla__viewport');
      if (!viewport) continue;

      const embla = EmblaCarousel(viewport, {
        loop: false,
        align: 'start',
        slidesToScroll: 1,
        containScroll: 'trimSnaps',
      });

      const prevButton = carousel.querySelector('[data-carousel-prev]');
      const nextButton = carousel.querySelector('[data-carousel-next]');

      const updateButtons = () => {
        if (prevButton) prevButton.disabled = !embla.canScrollPrev();
        if (nextButton) nextButton.disabled = !embla.canScrollNext();
      };

      prevButton?.addEventListener('click', () => embla.scrollPrev());
      nextButton?.addEventListener('click', () => embla.scrollNext());

      embla.on('select', updateButtons);
      embla.on('reInit', updateButtons);
      updateButtons();
    }
  };

  initCarousel();
});
